import {QueryClient} from '@tanstack/react-query';

export const invalidateUserQueries = (queryClient: QueryClient, userId?: string) => {
    queryClient.invalidateQueries({
        predicate: (query) => {
            const queryKey = query.queryKey;
            if (!Array.isArray(queryKey)) return false;

            const isUserQuery = queryKey.includes('getUser');
            const isUserProfileQuery = queryKey.includes('getUserProfileData');

            if (!isUserQuery && !isUserProfileQuery) {
                return false;
            }

            if (userId) {
                return queryKey.some(key =>
                    typeof key === 'object' &&
                    key !== null &&
                    'user_id' in key &&
                    key.user_id === userId
                );
            }

            return true;
        },
    });
};

export const invalidateAvatarQueries = (queryClient: QueryClient, fileId?: string) => {
    queryClient.invalidateQueries({
        predicate: (query) => {
            const queryKey = query.queryKey;
            if (!Array.isArray(queryKey)) return false;

            const isAvatarQuery = queryKey[0] === 'avatar';

            if (!isAvatarQuery) {
                return false;
            }

            if (fileId) {
                return queryKey.includes(fileId);
            }

            return true;
        },
    });
};

export const invalidateUserAndAvatarQueries = (queryClient: QueryClient, userId?: string) => {
    invalidateUserQueries(queryClient, userId);
    invalidateAvatarQueries(queryClient);
};
